import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores';

export function RoleBasedRedirect() {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'SuperAdmin' || user.role === 'platform_admin') {
    return <Navigate to="/superadmin" replace />;
  }

  const isStudioUser = user.role === 'Instructor' || user.role === 'StudioOwner';

  if (isStudioUser) {
    return <Navigate to="/studio" replace />;
  }

  // Fallback for any other roles or if role is not defined
  return <Navigate to="/unauthorized" replace />;
}